// Author: Kevin Thomas : XKO
// Date: 02/11/04
// JOB 22124

// This file contains barcode check-digit javascript functions for Modulo43
import ccd_GetFullASCIIcode from "./BarcodeCCD_GetFullASCIIcode";
import ccd_GetFullASCIIchar from "./BarcodeCCD_GetFullASCIIchar";
function ccd_Modulo43(strCode) {
  var i, intTot, chrCurr, intLen, intCharVal, chrCheck;

  intTot = 0;

  intLen = strCode.length;

  for (i = 0; i < intLen; i++) {
    chrCurr = strCode.charAt(i);
    intTot += ccd_GetFullASCIIcode(chrCurr);
  }

  intCharVal = intTot % 43;

  chrCheck = ccd_GetFullASCIIchar(intCharVal);

  return chrCheck;
}
export default ccd_Modulo43;
